import axios from 'axios'
const CancleToken = axios.CancelToken
/** 监控中心leaflet版本，地图功能部分
 */
const leafLetCtl = {
  /** 获取设备定位详细信息
   * @param _this {object} 页面指针
   * * @param url {string} 接口地址
   * * * @param devIdList {Array} 设备ID
   */
  getLocationByDevId(_this, url, devIdList) {
    _this.$axios({
      method: 'post',
      url: url,
      data: {
        devIdList: devIdList
      },
      cancelToken: new CancleToken(function (c) {
        _this.cancel = c
      }),
      headers: {
        Authorization: sessionStorage.getItem('token')
      }
    }).then(function (resp) {
      if (resp.data.code === 200) {
        resp.data.data.pag[0].devId = resp.data.data.pag[0].devId.toString()// 转成string防止丢失精度
        _this.fitBoundsList = []
        _this.watchDeviceList = resp.data.data.pag
        let carKeyList = [5, 23, 24, 25, 26, 27, 28, 29, 32, 33, 42, 43, 40]
        let shipList = [6, 31]
        let angle = 0
        let dataNum = resp.data.data.pag.length
        let flag = null
        if (dataNum > 0 && dataNum >= _this.markerList.length) {
          if (_this.markerList.length > 0) {
            for (let i = 0; i < dataNum; i++) {
              angle = 0
              if (carKeyList.indexOf(resp.data.data.pag[i].devModel) > -1 || shipList.indexOf(resp.data.data.pag[i].devModel) > -1) {
                angle = resp.data.data.pag[i].lDirection
              }
              for (let j = 0; j < _this.markerList.length; j++) {
                if (resp.data.data.pag[i].devId === _this.markerList[j].options.id) {
                  // 更新点坐标、方向
                  if (resp.data.data.pag[i].cId !== null && resp.data.data.pag[i].cId !== '' && resp.data.data.pag[i].devModel === 30) {
                    _this.markerList[j].setIcon(
                      _this.$L.icon({
                        iconUrl: require('../../assets/images/高精度/报警.png'),
                        iconSize: [40, 40],
                        popupAnchor: [-3, -76]
                      })
                    )
                  }
                  if (resp.data.data.pag[i].lLatWgs84 !== null && resp.data.data.pag[i].lLatWgs84 !== '' && resp.data.data.pag[i].lLonWgs84 !== null && resp.data.data.pag[i].lLonWgs84 !== '') {
                    _this.markerList[j].setLatLng(_this.$L.latLng(resp.data.data.pag[i].lLatWgs84, resp.data.data.pag[i].lLonWgs84))
                    _this.markerCluster.eachLayer(function (layer) {
                      if (layer.options.id === resp.data.data.pag[i].devId) {
                        _this.icon = _this.$cautionIconFun.setIconAndPopupHtmlLLMap(_this, resp.data.data.pag[i])
                        layer.setLatLng(_this.$L.latLng(resp.data.data.pag[i].lLatWgs84, resp.data.data.pag[i].lLonWgs84))
                        layer.setIcon(_this.icon)
                        layer.setRotationAngle(angle)
                      }
                    })
                    _this.map.eachLayer(function (layer) {
                      if (layer.options.id === 'popup') {
                        layer.setLatLng(_this.$L.latLng(resp.data.data.pag[i].lLatWgs84, resp.data.data.pag[i].lLonWgs84))
                      }
                    })
                    _this.fitBoundsList.push(_this.$L.latLng(resp.data.data.pag[i].lLatWgs84, resp.data.data.pag[i].lLonWgs84))
                    _this.markerCluster.refreshClusters()
                  }
                  flag = true
                  break
                } else {
                  flag = false
                }
              }
              if (flag === false) {
                _this.icon = _this.$cautionIconFun.setIconAndPopupHtmlLLMap(_this, resp.data.data.pag[i])
                let lat = 0.0000000
                let lng = 0.0000000
                if (resp.data.data.pag[i].lLatWgs84 !== null && resp.data.data.pag[i].lLonWgs84 !== null) {
                  _this.fitBoundsList.push(_this.$L.latLng(resp.data.data.pag[i].lLatWgs84, resp.data.data.pag[i].lLonWgs84))
                  _this.markerCluster.refreshClusters()
                  lat = resp.data.data.pag[i].lLatWgs84
                  lng = resp.data.data.pag[i].lLonWgs84
                }
                _this.markerList.push(
                  _this.$L.marker([lat, lng], {
                    id: resp.data.data.pag[i].devId,
                    icon: _this.icon,
                    rotationAngle: angle,
                    rotationOrigin: 'center center'
                  })
                )
                _this.markerCluster.addLayer(_this.$L.marker([resp.data.data.pag[i].lLatWgs84, resp.data.data.pag[i].lLonWgs84], {
                  id: resp.data.data.pag[i].devId,
                  icon: _this.icon,
                  rotationAngle: angle,
                  rotationOrigin: 'center center'
                }))
              }
            }
          } else if (_this.markerList.length === 0) {
            for (let i = 0; i < dataNum; i++) {
              angle = 0
              if (carKeyList.indexOf(resp.data.data.pag[i].devModel) > -1 || shipList.indexOf(resp.data.data.pag[i].devModel) > -1) {
                angle = resp.data.data.pag[i].lDirection
              }
              _this.icon = _this.$cautionIconFun.setIconAndPopupHtmlLLMap(_this, resp.data.data.pag[i])
              let lat = 0.0000000
              let lng = 0.0000000
              if (resp.data.data.pag[i].lLatWgs84 !== null && resp.data.data.pag[i].lLonWgs84 !== null) {
                _this.fitBoundsList.push(_this.$L.latLng(resp.data.data.pag[i].lLatWgs84, resp.data.data.pag[i].lLonWgs84))
                _this.markerCluster.refreshClusters()
                lat = resp.data.data.pag[i].lLatWgs84
                lng = resp.data.data.pag[i].lLonWgs84
              }
              _this.markerList.push(
                _this.$L.marker([lat, lng], {
                  id: resp.data.data.pag[i].devId,
                  icon: _this.icon,
                  rotationAngle: angle,
                  rotationOrigin: 'center center'
                })
              )
              _this.markerCluster.addLayer(_this.$L.marker([lat, lng], {
                id: resp.data.data.pag[i].devId,
                icon: _this.icon,
                rotationAngle: angle,
                rotationOrigin: 'center center'
              }))
            }
          }
        } else if (dataNum > 0 && dataNum < _this.markerList.length) {
          for (let j = 0; j < _this.markerList.length; j++) {
            for (let i = 0; i < dataNum; i++) {
              angle = 0
              if (carKeyList.indexOf(resp.data.data.pag[i].devModel) > -1 || shipList.indexOf(resp.data.data.pag[i].devModel) > -1) {
                angle = resp.data.data.pag[i].lDirection
              }
              if (_this.markerList[j].options.id === resp.data.data.pag[i].devId) {
                if (resp.data.data.pag[i].cId !== null && resp.data.data.pag[i].cId !== '' && resp.data.data.pag[i].devModel === 30) {
                  _this.markerList[j].setIcon(
                    _this.$L.icon({
                      iconUrl: require('../../assets/images/高精度/报警.png'),
                      iconSize: [40, 40],
                      popupAnchor: [-3, -76]
                    })
                  )
                }
                if (resp.data.data.pag[i].lLatWgs84 !== null && resp.data.data.pag[i].lLatWgs84 !== '' && resp.data.data.pag[i].lLonWgs84 !== null && resp.data.data.pag[i].lLonWgs84 !== '') {
                  _this.markerList[j].setLatLng(_this.$L.latLng(resp.data.data.pag[i].lLatWgs84, resp.data.data.pag[i].lLonWgs84))
                  if (resp.data.data.pag[i].lLatWgs84 !== null && resp.data.data.pag[i].lLonWgs84 !== null) {
                    _this.markerCluster.eachLayer(function (layer) {
                      if (layer.options.id === resp.data.data.pag[i].devId) {
                        _this.icon = _this.$cautionIconFun.setIconAndPopupHtmlLLMap(_this, resp.data.data.pag[i])
                        layer.setLatLng(_this.$L.latLng(resp.data.data.pag[i].lLatWgs84, resp.data.data.pag[i].lLonWgs84))
                        layer.setIcon(_this.icon)
                        layer.setRotationAngle(angle)
                      }
                    })
                    _this.map.eachLayer(function (layer) {
                      if (layer.options.id === 'popup') {
                        layer.setLatLng(_this.$L.latLng(resp.data.data.pag[i].lLatWgs84, resp.data.data.pag[i].lLonWgs84))
                      }
                    })
                    _this.fitBoundsList.push(_this.$L.latLng(resp.data.data.pag[i].lLatWgs84, resp.data.data.pag[i].lLonWgs84))
                    _this.markerCluster.refreshClusters()
                  }
                }
                flag = true
                break
              } else {
                flag = false
              }
            }
            if (flag === false) {
              _this.markerCluster.eachLayer(function (layer) {
                if (layer.options.id === _this.markerList[j].options.id) {
                  _this.markerCluster.removeLayer(layer)
                }
              })
              _this.markerList.splice(j, 1)
            }
          }
        } else {
          _this.markerList.splice(0, _this.markerList.length)
        }
      }
      console.log('fitBoundsList', _this.fitBoundsList)
      if (_this.fitBoundsList.length > 5) {
        _this.map.fitBounds(_this.fitBoundsList, {
          padding: [200, 200]
        })
      }
    }).catch(resp => {
    })
  }
}
export default leafLetCtl



// WEBPACK FOOTER //
// ./src/javascript/function/monitorLeaflet.js